import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { CurrentLanguage } from '../../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { Subscription } from 'rxjs';
import { BrandType } from '../../../business-entities/vehicle-list-view-model';
import { BrandService } from '../../../business-services/brand.service';
import { Utility } from '../../../../../../Autofacets-Core/src/app/utils/utility';
import { LaborService } from '../../../business-services/labor.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LaborDetailsResponseModel } from '../../../business-entities/labor-details-view-model';
import { DecimalPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { GlobalSetting } from '../../../../../../Autofacets-Core/src/app/common-services/global-setting.service';
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { ToastrService } from 'ngx-toastr';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as fromEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-add-edit-labor',
  templateUrl: './add-edit-labor.component.html'
})
export class AddEditLaborComponent implements OnInit {
  isFormValid: boolean = false;
  LaborForm: FormGroup;
  currentlagSub: Subscription;
  makeList: BrandType[] = [];
  makeCode: string;
  fixedPrice: string;
  Id: number;
  chargingGroup:any;
  chargingGroupList:any;
  languageList: any[];
  laborDetail: LaborDetailsResponseModel;
  VATPercentage:number=0;
  allowDealerBrandLaborRate:boolean = false;
  subscription : Subscription;
  isDmsSyncLabor : boolean = false;
  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private currentLanguageService: CurrentLanguage,
    private brandService: BrandService,
    private laborService: LaborService,
    private spinner: NgxSpinnerService,
    private decimalPipe: DecimalPipe,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    private globalSetting: GlobalSetting,
    private toaster: ToastrService,
    private secureStorage: SecureStorage,
    private numberPipe: DecimalPipe
  ) { }

  ngOnInit(): void {
    this.Id = this.laborService.Id;
    this.VATPercentage=this.secureStorage.getKeyData('VATPercentage');
    this.LaborForm = this.formBuilder.group({
      labor: new FormArray([]),
      makeCode: ['', [Validators.required]],
      fixedPrice: [null, [Validators.required, Validators.pattern(/\d+\.?\d*/)]],
      duration: ['', [Validators.required]],
      laborNumber: ['', [Validators.required]],
      isActive: [true],
      isFixed: [false],
      chargingGroup:[''],
      priceInclVAT:[null, [Validators.required, Validators.pattern(/\d+\.?\d*/)]]
    });
    this.languageList = this.currentLanguageService.LanguageList;
    this.getLanguage();
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
      this.GetAllMake();
    });
    this.getFeatures();
    if(!this.allowDealerBrandLaborRate){
      this.getChargingGroupDropDown();
    }
    this.LaborForm.controls['chargingGroup'].disable();

    
  }
  ngOnDestroy(): void {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }
  async getFeatures() {
    let features = this.secureStorage.getKeyData('feature');
    if(features == null || features == undefined){
      this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
        features = res;
        if (features?.length > 0) {
          this.isDmsSyncLabor = features.find(x => x.featureCode === fromEnums.FeatureCode.RTDSL)?.isActive
          this.allowDealerBrandLaborRate = features.find(x => x.featureCode === fromEnums.FeatureCode.AllowDealerBrandLaborRate)?.isActive;
        }
      })
    }else{
       this.isDmsSyncLabor = features.find(x => x.featureCode === fromEnums.FeatureCode.RTDSL)?.isActive
        this.allowDealerBrandLaborRate = features.find(x => x.featureCode === fromEnums.FeatureCode.AllowDealerBrandLaborRate)?.isActive;
    }
  }

  OnClose() {
    this.isFormValid = false;
    this.activeModal.close({ success: false });
  }
  CheckDuration(event) {
    if (event.inputType != 'deleteContentBackward') {
      if (this.LaborForm.value.duration.length == 2) {
        this.LaborForm.patchValue({
          duration: this.LaborForm.value.duration + ':',
        })
      }
    }
  }
  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['',],
          name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }
  }

  get t() { return this.cpf.labor as FormArray; }

  get cpf() {
    return this.LaborForm.controls;
  }

  async GetAllMake(): Promise<void> {
    this.makeList = await this.brandService.GetBrandDropdownResult();
      if (this.Id > 0) {
        this.getLaborDetails(this.Id);
      } else {
        this.cdr.detectChanges();
        this.LaborForm.patchValue({
          fixedPrice: this.allowDealerBrandLaborRate 
            ? this.decimalPipe.transform(parseFloat('0'), '1.2-2')
            : this.decimalPipe.transform(parseFloat(this.secureStorage.getKeyData('LaborUnitPrice')), '1.2-2'),
          duration:Utility.ConvertMinutesToTime(this.secureStorage.getKeyData('LaborDurationInMinute')),
        });
        let priceInclVAT = this.numberPipe.transform(Utility.GetPriceInludingVAT(this.globalSetting.getFormattedprice(this.LaborForm.value.fixedPrice),this.VATPercentage),"1.2-2");
        this.LaborForm.patchValue({
          priceInclVAT:priceInclVAT
        })
        this.cdr.detectChanges();
      }

  }

  public onChangeIsActive(value: any) {
    this.LaborForm.value.isActive = value.target.checked;
  }

  public onChangeIsFixed(value: any) {
    this.LaborForm.value.isFixed = value.target.checked;
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  onBlur(event) {
    this.fixedPrice = event.target.value;
    let price= this.globalSetting.getFormattedprice(JSON.parse(JSON.stringify(event.target.value)));
    let priceInclVAT = Utility.GetPriceInludingVAT(price,this.VATPercentage);
    this.LaborForm.patchValue({
      priceInclVAT : this.numberPipe.transform(priceInclVAT,"1.2-2") 
    })
  }
  AddEditLabor() {
    let addSuccessMessage = this.translate.instant("lblLaborDetailsAreAdded");
    let addErrorMessage = this.translate.instant("lblLaborDetailsAreNotAdded");
    let editSuccessMessage = this.translate.instant("lblLaborDetailsAreEdited");
    let editErrorMessage = this.translate.instant("lblLaborDetailsAreNotEdited");
    let duration = Utility.ConvertTimeToMinutes(this.LaborForm.value.duration)
    if (duration > 1200) {
      let errormsg = this.translate.instant("lblExceedDurationtimelimit");
      this.toaster.error(errormsg);
      return;
    }

    this.spinner.show();
    let viewModel = {
      name: this.LaborForm.value.labor,
      fixedPrice: this.globalSetting.getFormattedprice(this.LaborForm.value.fixedPrice),
      Duration: duration,
      makeCode: this.makeCode,
      Id: this.laborService.Id,
      IsActive: this.LaborForm.value.isActive, // this.ServiceInfo.serviceDetails[0].isActive,
      laborNumber: this.LaborForm.value.laborNumber,
      sourceTypeId: 1,
      IsFixed: this.LaborForm.value.isFixed,
      chargingGroupCode : this.LaborForm.controls['chargingGroup'].value,
      IsDmsSyncLabor : this.isDmsSyncLabor
    }
    this.laborService.AddUpdateLabor(viewModel).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        if (res.responseObject) {
          if (res.responseObject.isSuccess) {
            let successMessage = (this.laborService.Id == 0) ? addSuccessMessage : editSuccessMessage
            this.toaster.success(successMessage);
            this.spinner.hide();
            this.activeModal.close({ success: true });
          }
          else {
            this.spinner.hide();
            let errormsg = this.translate.instant("lblAlreadyExistsLaborNumber");
            this.toaster.error(errormsg);
          }
        }

      }
      else {
        let errorMessage = (this.laborService.Id == 0) ? addErrorMessage : editErrorMessage
        this.spinner.hide();
        this.toaster.error(errorMessage);
      }
    }, _error => {
      let errorMessage = (this.laborService.Id == 0) ? addErrorMessage : editErrorMessage
      this.spinner.hide();
      this.toaster.error(errorMessage);
    });
  }

  async getLaborDetails(id) {
    this.spinner.show();

    await this.laborService.getLaborById(id).then((response) => {
      this.laborDetail = response.responseObject;
      this.cdr.detectChanges();
      this.LaborForm.patchValue({
        laborNumber: this.laborDetail.laborDetails[0].laborNo,
        fixedPrice: this.decimalPipe.transform(this.laborDetail.laborDetails[0].fixedPrice, '1.2-2'),
        duration:Utility.ConvertMinutesToTime(this.laborDetail.laborDetails[0].duration.toString()),
        isActive: this.laborDetail.laborDetails[0].isActive,
        isFixed: this.laborDetail.laborDetails[0].isFixed,
        priceInclVAT : this.numberPipe.transform(this.laborDetail.laborDetails[0].priceInclVat,"1.2-2")
      });
      this.cdr.detectChanges();
      this.makeCode = this.laborDetail.laborDetails[0].makeCode;
      this.spinner.hide();
    }, _error => {
      this.spinner.hide();
    });
  }
  async getChargingGroupDropDown() {
    this.spinner.show();
    await this.laborService.getChargingGroupDropDown().then((response) => {
      this.spinner.hide()
      this.chargingGroupList = response.responseObject;
      if(this.chargingGroupList != null && this.chargingGroupList.length > 0){
        let defaultValueGroupChargingCode = this.chargingGroupList.filter((x:any)=>x.isDefault);
        if(defaultValueGroupChargingCode.length > 0 ){
          this.LaborForm.patchValue({
            chargingGroup : defaultValueGroupChargingCode[0].groupNo
          })
        }
      }
    }, _error => {
      this.spinner.hide()
    });
  }
}
